import { OpenAPI } from "./core/OpenAPI";

/**
 * モックモードの状態を管理するユーティリティ
 */

// ローカルストレージのキー
const MOCK_MODE_KEY = "app_use_mock_api";

// 本番環境かどうかの判定
const isProduction = process.env.NODE_ENV === "production";

/**
 * モックモードを有効にする
 */
export const enableMockMode = (): void => {
  // 本番環境では常に無効
  if (isProduction) {
    return;
  }

  OpenAPI.USE_MOCK = true;
  try {
    localStorage.setItem(MOCK_MODE_KEY, "true");
  } catch (e) {
    console.warn("ローカルストレージにアクセスできません", e);
  }
  console.info("🔶 モックモードが有効になりました");
};

/**
 * モックモードを無効にする
 */
export const disableMockMode = (): void => {
  OpenAPI.USE_MOCK = false;
  try {
    localStorage.setItem(MOCK_MODE_KEY, "false");
  } catch (e) {
    console.warn("ローカルストレージにアクセスできません", e);
  }
  console.info("🔷 モックモードが無効になりました");
};

/**
 * モックモードを切り替える
 * @returns 切り替え後のモックモードの状態
 */
export const toggleMockMode = (): boolean => {
  // 本番環境では常に無効
  if (isProduction) {
    disableMockMode();
    console.info("🔷 本番環境ではモックモードは使用できません");
    return false;
  }

  if (OpenAPI.USE_MOCK) {
    disableMockMode();
    return false;
  }

  enableMockMode();
  return true;
};

/**
 * 現在のモックモードの状態を取得する
 * @returns モックモードが有効かどうか
 */
export const isMockModeEnabled = (): boolean => {
  // 本番環境では常に無効
  if (isProduction) {
    return false;
  }
  return OpenAPI.USE_MOCK;
};

/**
 * ローカルストレージからモックモードの設定を読み込む
 * アプリケーション起動時に呼び出すことで、前回の設定を復元できる
 */
export const loadMockModeFromStorage = (): void => {
  // 本番環境では常に無効
  if (isProduction) {
    OpenAPI.USE_MOCK = false;
    console.info("🔷 本番環境ではモックモードは使用できません");
    return;
  }

  try {
    const storedValue = localStorage.getItem(MOCK_MODE_KEY);
    if (storedValue === "true") {
      OpenAPI.USE_MOCK = true;
      console.info("🔶 モックモードが有効になりました（ストレージから復元）");
    } else if (storedValue === "false") {
      OpenAPI.USE_MOCK = false;
      console.info("🔷 モックモードが無効になりました（ストレージから復元）");
    }
    // storedValueがnullの場合は何もしない（デフォルト値を使用）
  } catch (e) {
    console.warn(
      "ローカルストレージからモックモード設定を読み込めませんでした",
      e,
    );
  }
};
